import { FormDataRestClient } from '../../api/rest_interceptor';
import { GRAPHQL_API } from '../../api/graphql/endpoint';
import graphqlClient from '../../api/axios_interceptor';
import { getFormData } from './functions';
import {
    FETCH_BANK_STATEMENT_TRANSACTIONS,
    SAVE_BANK_STATEMENT_TRANSACTIONS
} from '../actions/actionTypes';
import { updateActionErrors } from './updateErrors';
import {
    fetchBankStatementTransactionsQuery,
    saveBankStatementTransactionsMutation
} from "../../api/graphql/queries/bankStatement";
import { parsePayment } from './payments';


const fetchBankStatementTransactionsMiddleware = async (action) => {
    try {
        const payload = action.payload;
        let query = fetchBankStatementTransactionsQuery();
        const formData = getFormData(query, action.payload.fileUpload);
        await FormDataRestClient.post(GRAPHQL_API, formData).then(
            (queryResult) => {
                if (queryResult.data.errors) {
                    action = updateActionErrors(action, queryResult.data.errors);
                } else {
                    action = ({
                        ...action,
                        payload: {
                            ...payload,
                            transactions: queryResult.data.data.getBankStatementTransactions
                        }
                    });
                }
        });
    } catch (error) {
        console.log(error);
        action = updateActionErrors(action, error);
    }
    return action;
}

const saveBankStatementTransactionsMiddleware = async (action) => {
    try {
        await graphqlClient({
            data: {
                query: saveBankStatementTransactionsMutation(action.payload.transactions)
            },
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
            } else if (queryResult.data.data.saveBankStatement.errorMessage) {
                action = updateActionErrors(action, queryResult.data.data.saveBankStatement.errorMessage);
            } else {
                action = ({
                    ...action,
                    payload: {
                        ...action.payload,
                        payments: queryResult.data.data.saveBankStatement.payments.map(parsePayment)
                    }
                });
            }
        });
    } catch (error) {
        console.log(error);
        action = updateActionErrors(action, error);
    }
    return action;
}


export const BankStatementMiddleware = storeAPI => next => async action => {
    switch (action.type) {
        case FETCH_BANK_STATEMENT_TRANSACTIONS:
            action = await fetchBankStatementTransactionsMiddleware(action);
            break;
        case SAVE_BANK_STATEMENT_TRANSACTIONS:
            action = await saveBankStatementTransactionsMiddleware(action);
            break;
    }
    return next(action);
}